import { apiGetOne } from './ApiBaseActions';
export const API_GET_PROFFIT_SEARCH_SLIDE_INFORMATION_TOP = 'API_GET_PROFFIT_SEARCH_SLIDE_INFORMATION_TOP';
export const API_GET_PROFFIT_SEARCH_SLIDE_INFORMATION_TOP_SUCCESS = 'API_GET_PROFFIT_SEARCH_SLIDE_INFORMATION_TOP_SUCCESS';
export const SET_PROFFIT_SEARCH_INFORMATION_TOP_MODAL_UPLOAD_GROUP_ID = 'SET_PROFFIT_SEARCH_INFORMATION_TOP_MODAL_UPLOAD_GROUP_ID';
export const SHOW_PROFFIT_SEARCH_INFORMATION_TOP_MODAL_PROGRESS = 'SHOW_PROFFIT_SEARCH_INFORMATION_TOP_MODAL_PROGRESS';
export const HIDE_PROFFIT_SEARCH_INFORMATION_TOP_MODAL_PROGRESS = 'HIDE_PROFFIT_SEARCH_INFORMATION_TOP_MODAL_PROGRESS';
export const UPDATE_PROFFIT_SEARCH_INFORMATION_TOP_MODAL_PROGRESS = 'UPDATE_PROFFIT_SEARCH_INFORMATION_TOP_MODAL_PROGRESS';
export const SHOW_PROFFIT_SEARCH_INFORMATION_TOP_MODAL_COMPLETE = 'SHOW_PROFFIT_SEARCH_INFORMATION_TOP_MODAL_COMPLETE';
export const HIDE_PROFFIT_SEARCH_INFORMATION_TOP_MODAL_COMPLETE = 'HIDE_PROFFIT_SEARCH_INFORMATION_TOP_MODAL_COMPLETE';
export const SET_PROFFIT_SEARCH_INFORMATION_TOP_UPLOAD_ITEMS = 'SET_PROFFIT_SEARCH_INFORMATION_TOP_UPLOAD_ITEMS';
export const UPDATE_PROFFIT_SEARCH_INFORMATION_TOP_UPLOAD_ITEMS = 'UPDATE_PROFFIT_SEARCH_INFORMATION_TOP_UPLOAD_ITEMS';
export const UPDATE_REMOVE_PROFFIT_SEARCH_INFORMATION_TOP_UPLOAD_ITEMS = 'UPDATE_REMOVE_PROFFIT_SEARCH_INFORMATION_TOP_UPLOAD_ITEMS';
export const CLEAR_PROFFIT_SEARCH_INFORMATION_TOP_UPLOAD_ITEMS = 'CLEAR_PROFFIT_SEARCH_INFORMATION_TOP_UPLOAD_ITEMS';
/**
 * TOPで参照する情報を取得
 * @param meta
 * @returns {{payload: {}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: string}, type: string}}
 */
export const apiGetOneProffitSearchInformationTop = (meta) => apiGetOne(API_GET_PROFFIT_SEARCH_SLIDE_INFORMATION_TOP, '/proffit_search/information_top', meta || {});
/**
 * 現在処理中のグループIDの設定
 * @param currentUploadGroupId
 * @returns {{payload: {currentUploadGroupId}, type: string}}
 */
export const setProffitSearchInformationTopModalUploadGroupId = (currentUploadGroupId) => ({
    payload: { currentUploadGroupId },
    type: SET_PROFFIT_SEARCH_INFORMATION_TOP_MODAL_UPLOAD_GROUP_ID,
});
/**
 * 進捗モーダルの表示
 * @param modalId
 * @param addItems
 * @returns {{payload: {modalId, addItems}, type: string}}
 */
export const showProffitSearchInformationTopModalProgress = (modalId, addItems) => ({
    payload: { addItems, modalId },
    type: SHOW_PROFFIT_SEARCH_INFORMATION_TOP_MODAL_PROGRESS,
});
/**
 * 進捗モーダルの非表示
 * @param modalId
 * @param isForce
 * @returns {{payload: {modalId, isForce}, type: string}}
 */
export const hideProffitSearchInformationTopModalProgress = (modalId, isForce) => ({
    payload: { isForce, modalId },
    type: HIDE_PROFFIT_SEARCH_INFORMATION_TOP_MODAL_PROGRESS,
});
/**
 * 進捗モーダルの更新
 * @param modalId
 * @param currentUploadGroupId
 * @param modalInformation
 * @returns {{payload: {modalInformation, modalId, currentUploadGroupId}, type: string}}
 */
export const updateProffitSearchInformationTopModalProgress = (modalId, currentUploadGroupId, modalInformation) => ({
    payload: { currentUploadGroupId, modalId, modalInformation },
    type: UPDATE_PROFFIT_SEARCH_INFORMATION_TOP_MODAL_PROGRESS,
});
/**
 * 完了モーダルの表示
 * @param modalInformation
 * @returns {{payload: {modalInformation}, type: string}}
 */
export const showProffitSearchInformationTopModalComplete = (modalInformation) => ({
    payload: { modalInformation },
    type: SHOW_PROFFIT_SEARCH_INFORMATION_TOP_MODAL_COMPLETE,
});
/**
 * 完了モーダルの非表示
 * @returns {{type: string}}
 */
export const hideProffitSearchInformationTopModalComplete = () => ({
    type: HIDE_PROFFIT_SEARCH_INFORMATION_TOP_MODAL_COMPLETE,
});
/**
 * アップロード中のアイテムの表示
 * @returns {{type: string}}
 */
export const setProffitSearchInformationTopUploadItems = (items) => ({
    payload: { items },
    type: SET_PROFFIT_SEARCH_INFORMATION_TOP_UPLOAD_ITEMS,
});
/**
 * アップロード中のアイテムの更新
 * @param updateItemSettings
 * @returns {{payload: {updateItemSettings}, type: string}}
 */
export const updateProffitSearchInformationTopUploadItemItems = (updateItemSettings) => ({
    payload: { updateItemSettings },
    type: UPDATE_PROFFIT_SEARCH_INFORMATION_TOP_UPLOAD_ITEMS,
});
/**
 * アップロード中のアイテムの削除
 * @param updateItemSettings
 * @returns {{payload: {updateItemSettings}, type: string}}
 */
export const updateRemoveProffitSearchInformationTopUploadItemItems = (updateItemSettings) => ({
    payload: { updateItemSettings },
    type: UPDATE_REMOVE_PROFFIT_SEARCH_INFORMATION_TOP_UPLOAD_ITEMS,
});
/**
 * アップロード中のアイテムの削除
 * @returns {{type: string}}
 */
export const clearProffitSearchInformationTopUploadItems = () => ({
    type: CLEAR_PROFFIT_SEARCH_INFORMATION_TOP_UPLOAD_ITEMS,
});
